import script from "./Skeleton.vue?vue&type=script&setup=true&lang=ts"
export * from "./Skeleton.vue?vue&type=script&setup=true&lang=ts"

import "./Skeleton.vue?vue&type=style&index=0&id=111b2452&lang=scss"

const __exports__ = script;

export default __exports__